import React from 'react'
import { createInstance } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import IconPl from '@ads/front-core/Icons/IconPl'
import IconEn from '@ads/front-core/Icons/IconEn'
import { SupportedLanguages } from '@ads/front-core/translations-api'
import ITranslations from '@ads/front-core/locales/interface'
import pl from '@ads/front-core/locales/pl/translation.json'
import en from '@ads/front-core/locales/en/translation.json'
import de from '@ads/front-core/locales/de/translation.json'
import cz from '@ads/front-core/locales/cz/translation.json'

export const resources = {
  pl,
  en,
  de,
  cz,
}

export type TSupportedLanguages = keyof SupportedLanguages
export type TTranslationsKeys = keyof ITranslations

export type TLanguages = {
  lang: TSupportedLanguages
  nameToDisplay: string
  nameToDisplayUCFirst: string
  icon?: React.ReactElement
  isHidden?: boolean
}

export const languages: TLanguages[] = [
  {
    lang: 'pl',
    nameToDisplay: 'polski',
    nameToDisplayUCFirst: 'Polski',
    icon: <IconPl />,
  },
  {
    lang: 'en',
    nameToDisplay: 'english',
    nameToDisplayUCFirst: 'English',
    icon: <IconEn />,
  } /*
  {
    lang: 'cz',
    nameToDisplay: 'cesky',
    nameToDisplayUCFirst: 'Česky',
    icon: <IconEn />,
    isHidden: true,
  },
  {
    lang: 'de',
    nameToDisplay: 'deutsch',
    nameToDisplayUCFirst: 'Deutsch',
    icon: <IconEn />,
    isHidden: true,
  },*/,
]

export const LANGUAGE_COOKIE_KEY = 'i18next'

export const instance = createInstance()

if (typeof window !== 'undefined') {
  instance.use(LanguageDetector)
}

const DEFAULT_LANGUAGE: TSupportedLanguages = 'pl'

export const createI18nInstance = (withModules?: any) => {
  if (withModules) {
    instance.use(withModules)
  }

  instance.init({
    supportedLngs: languages
      .filter(language => !language.isHidden)
      .map(language => language.lang),
    fallbackLng: DEFAULT_LANGUAGE,
    detection: {
      order: ['cookie', 'htmlTag', 'navigator'],
      lookupCookie: LANGUAGE_COOKIE_KEY,
      caches: ['cookie'],
    },
    resources,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
  return instance
}

export const i18n = createI18nInstance()

export const currentLanguage = (i18n.language ||
  DEFAULT_LANGUAGE) as TSupportedLanguages
export const currentLanguageUpperCase = currentLanguage?.toUpperCase()

export const decimalSeparator = currentLanguage === 'pl' ? ',' : '.'
